import { TodoSerializer } from "./serializers/todoSerializer";
import { Todo } from "./todo.model";
import { Ad } from "./Ad.model";
import { EngagementAction } from "./engagementAction";

export type LaunchAdStatus =
  | "TODO"
  | "IN_PROGRESS"
  | "APPROVED"
  | "IN_REVIEW"
  | "CHANGES_REQUESTED"
  /** Rejected and not to be offered to this client again (MPN-1612). */
  | "DO_NOT_USE";

export class LaunchAd {
  id: number;
  launch_id: number;
  ad_id: number;
  status: LaunchAdStatus;
  review_todo_id?: number;
  review_todo: Todo | null;
  /** Name of the template this ad was rebranded from (MPN-1508). Carried on the row
      rather than on the Ad, because the same Ad payload is served to the client
      review panel and clients must not see it. */
  source_template_name: string | null;
  ad?: Ad;
  my_action: EngagementAction | null;
  /** Whether utm_source=motimatic is appended to this ad's destination URL on THIS
      campaign (MPN-1536). Per-campaign rather than per-ad, because an Ad is shared:
      the same template can run for several clients at once. */
  append_utm: boolean;
  /** The URL the ad will actually publish with, tag included or not. Read straight
      from the server rather than rebuilt here, so the approval view and the networks
      can never disagree about what the client is approving. */
  destination_url: string | null;

  constructor(data?: Partial<LaunchAd>) {
    this.id = data?.id ?? 0;
    this.launch_id = data?.launch_id ?? 0;
    this.ad_id = data?.ad_id ?? 0;
    this.status = (data?.status ?? "TODO").toString().toUpperCase() as LaunchAdStatus;
    this.review_todo_id = data?.review_todo_id;
    if (data?.review_todo) {
      this.review_todo = new TodoSerializer().deserialize(data?.review_todo);
    } else {
      this.review_todo = null;
    }
    this.source_template_name = data?.source_template_name ?? null;
    this.ad = data?.ad;
    this.my_action = data?.my_action ?? null;
    // Defaults to true, matching the server's field default: a row that predates the
    // column should read as tagged, which is what it will actually publish as.
    this.append_utm = data?.append_utm ?? true;
    this.destination_url = data?.destination_url ?? null;
  }
}
